
import CategoriesReducer, * as Categories from './categories';
import ClaimQuestionsReducer from './claim_questions';
import ItemsReducer, * as Items from './items';
import { combineImmutableReducers } from '../../util';
import {Map} from 'immutable';

const DEFAULT_STATE = Map();

const reducer = combineImmutableReducers({
  categories: CategoriesReducer,
  claim_questions: ClaimQuestionsReducer,
  items: ItemsReducer
}, DEFAULT_STATE);

export default reducer;

export const getCategories = (state) => Categories.getCategories(state.get("categories"))

export const getItemsById = (state) => Items.getItemsById(state.get("items"))

export const getItemIds = (state) => Items.getItemIds(state.get("items"))

export const getDraftItem = (state) => Items.getDraftItem(state.get("items"));

export const getPendingItemIds = (state) => Items.getPendingItemIds(state.get("items"));

export const getPendingItems = (state) => Items.getPendingItems(state.get("items"));



// WEBPACK FOOTER //
// ./src/snapit_app/reducers/index.js